import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { INVENTORY_DASHBOARD_ERROR, GETTING_INVENTORY_DASHBOARD, GET_INVENTORY_DASHBOARD } from "../types"

export const fetchInventoryDashboardData = () => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: GETTING_INVENTORY_DASHBOARD,
            payload: true
        })

        const response = await axios.get(`${baseUrl}/dashboards/inventory`, { headers })
        
        dispatch({
            type: GET_INVENTORY_DASHBOARD,
            payload: response.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_DASHBOARD_ERROR,
            error
        })
    }
}
